import { EDiscountType } from "api/enums";
import InstallmentsModel from "./InstallmentsModel";

class DiscountModel extends InstallmentsModel {
  public readonly uid: string;
  public readonly contractUid: string;
  public readonly code: number;
  public title: string;
  public description: string;
  public readonly date: Date;
  public type: EDiscountType;
  public readonly createdAt: Date;
  public modifiedAt: Date;

  constructor(
    uid: string,
    contractUid: string = "",
    code: number = 0,
    title: string = "",
    description: string = "",
    date = new Date(),
    type = EDiscountType.DISCOUNT,
    installments,
    createAt = new Date(),
    modifiedAt = new Date()
  ) {
    super(date, installments);

    this.uid = uid;
    this.contractUid = contractUid;
    this.code = code;
    this.title = title;
    this.description = description;
    this.date = date;
    this.type = type as any;
    this.createdAt = createAt;
    this.modifiedAt = modifiedAt;
  }

  getDate(): Date | undefined {
    /** Cria nova instancia para não alterar a data do desconto. */
    return this.date ? new Date(this.date) : undefined;
  }

  toSave() {
    return {
      code: this.code,
      title: this.title,
      description: this.description,
      date: this.date,
      type: this.type,
      installments: [...this.installments],
      createdAt: this.createdAt,
      modifiedAt: this.modifiedAt,
    };
  }

  static create(uid: string, data: Partial<DiscountModel>): DiscountModel {
    return new DiscountModel(
      uid,
      data.contractUid,
      data.code,
      data.title,
      data.description,
      data.date,
      data.type,
      data.installments,
      data.createdAt,
      data.modifiedAt
    );
  }
}

export default DiscountModel;
